export default __webpack_public_path__ + "static/media/ic_chevron.712f2e7e.svg";